import { MenuItem, MenuSeparator } from '@/components/ui/menu';
import { Span } from '@chakra-ui/react';
import { EditPencil, NavArrowRight, Pause, Play, Trash } from 'iconoir-react';
import { useTranslation } from 'react-i18next';

interface AffiliateMembershipMenuItemsProps {
  valuePrefix: string;
  programName: string;
  onManage?: () => void;
  onPause?: () => void;
  onResume?: () => void;
  onRemove?: () => void;
  disabled?: boolean;
  compactManage?: boolean;
  nextStep?: boolean;
}

/** Same membership gestures and visual hierarchy in the table and the contact header. */
export default function AffiliateMembershipMenuItems({
  valuePrefix,
  programName,
  onManage,
  onPause,
  onResume,
  onRemove,
  disabled,
  compactManage = false,
  nextStep = false,
}: AffiliateMembershipMenuItemsProps) {
  const { t } = useTranslation();
  return (
    <>
      {onManage && (
        <MenuItem value={`${valuePrefix}:manage`} onSelect={onManage} closeOnSelect={!nextStep}>
          <EditPencil width={15} height={15} />
          <Span flex="1">
            {compactManage
              ? t('affiliates.membershipActions.manage')
              : t('affiliates.removal.manageProgram', { programName })}
          </Span>
          {nextStep && <NavArrowRight width={14} height={14} />}
        </MenuItem>
      )}
      {onPause && (
        <MenuItem
          value={`${valuePrefix}:pause`}
          disabled={disabled}
          onSelect={onPause}
          closeOnSelect={!nextStep}
        >
          <Pause width={15} height={15} />
          <Span flex="1">{t('affiliates.membershipActions.pause')}</Span>
          {nextStep && <NavArrowRight width={14} height={14} />}
        </MenuItem>
      )}
      {onResume && (
        <MenuItem
          value={`${valuePrefix}:resume`}
          disabled={disabled}
          onSelect={onResume}
          closeOnSelect={!nextStep}
        >
          <Play width={15} height={15} />
          <Span flex="1">{t('affiliates.membershipActions.resume')}</Span>
          {nextStep && <NavArrowRight width={14} height={14} />}
        </MenuItem>
      )}
      {onRemove && (
        <>
          <MenuSeparator />
          <MenuItem
            value={`${valuePrefix}:remove`}
            disabled={disabled}
            color="fg.error"
            _hover={{ bg: 'red.50', color: 'fg.error' }}
            onSelect={onRemove}
            closeOnSelect={!nextStep}
          >
            <Trash width={15} height={15} />
            <Span flex="1">{t('affiliates.removal.action')}</Span>
            {nextStep && <NavArrowRight width={14} height={14} />}
          </MenuItem>
        </>
      )}
    </>
  );
}
